import { render, staticRenderFns } from "./PhotosView.vue?vue&type=template&id=38b4cda4&scoped=true&"
import script from "./PhotosView.vue?vue&type=script&lang=js&"
export * from "./PhotosView.vue?vue&type=script&lang=js&"
import style0 from "./PhotosView.vue?vue&type=style&index=0&id=38b4cda4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b4cda4",
  null
  
)

export default component.exports